import { t } from 'localization/utils/t';
import { getTranslations } from 'shared/utils/getTranslations';
import {
  DRESSES_STYLES,
  PANTS_STYLES,
  SHORTS_STYLES,
  TOPS_STYLES,
} from 'productTemplate/enums/fitFeedback';

const TP = 'productTemplate.components.fitFeedback.FitFeedbackFormApparel';

export const dressesStyles = getTranslations(DRESSES_STYLES);
export const pantsStyles = getTranslations(PANTS_STYLES);
export const shortsStyles = getTranslations(SHORTS_STYLES);
export const topsStyles = getTranslations(TOPS_STYLES);

export const APPAREL_TYPE_MAP = {
  tops: {
    options: topsStyles,
    questions: [
      t(`${TP}.topsStyleQuestion`, 'What is the style of the top?'),
      t(`${TP}.topsSizePurchased`, 'What size top did you purchase?'),
      t(`${TP}.topsSizeFit`, 'How did the top end up fitting?'),
    ],
  },
  outerwear: {
    options: topsStyles,
    questions: [
      t(`${TP}.topsStyleQuestion`, 'What is the style of the top?'),
      t(`${TP}.topsSizePurchased`, 'What size top did you purchase?'),
      t(`${TP}.topsSizeFit`, 'How did the top end up fitting?'),
    ],
  },
  pants: {
    options: pantsStyles,
    questions: [
      t(`${TP}.bottomsStyleQuestion`, 'How would you describe the style of the bottom?'),
      t(`${TP}.bottomsSizePurchased`, 'What is the waist size of the bottom you purchased?'),
      t(`${TP}.bottomsSizeFit`, 'How did the bottom end up fitting?'),
    ],
  },
  shorts: {
    options: shortsStyles,
    questions: [
      t(`${TP}.shortsStyleQuestion`, 'How would you describe the style of the shorts?'),
      t(`${TP}.shortsSizePurchased`, 'What size shorts did you purchased?'),
      t(`${TP}.shortsSizeFit`, 'How did the shorts end up fitting?'),
    ],
  },
  dresses: {
    options: dressesStyles,
    questions: [
      t(`${TP}.dressesStyleQuestion`, 'How would you describe the style of the dress?'),
      t(`${TP}.dressesSizePurchased`, 'What size dress did you purchase?'),
      t(`${TP}.dressesSizeFit`, 'How did the dress end up fitting?'),
    ],
  },
};
